import { Typography } from "@mui/material";
import { formatCostString } from "utilities/currency/numberFormattingUtility";
import styles from "./TotalCostCard.module.scss";

interface TotalCostCardProps {
	sum: number;
}

const TotalCostCard = ({ sum }: TotalCostCardProps) => {
	return (
		<div className={styles.container}>
			<Typography variant="body1">Total cost</Typography>
			<Typography variant="body1" fontWeight={600}>
				{formatCostString("NOK ", sum, "")}
			</Typography>
		</div>
	);
};

export { TotalCostCard };
